<template>
  <div class="flex flex-col gap-4 border-b pb-8 md:pb-10" v-if="meals?.length">
    <AtomBlockHeaderSeo 
      :label="$t('city.start.offers.label', { city: fat.city?.name }) + ' ' + dayLabel" 
      :heading="$t('city.start.offers.heading', { city: fat.city?.name })"
    />
    <!-- <div class="grid gap-4 md:gap-6" :class="{ 'grid-cols-2': meals.length > 1, 'lg:grid-cols-3': meals.length === 3, 'xl:grid-cols-4': meals.length > 3 }">
      <div v-for="meal, key in meals?.slice(0, 4)" :key="meal.id">
        <OffersListCard 
          :horizontal="key > 11"
          :position="key+1"
          :meal="meal" 
          :restaurant="meal?.restaurant" />
      </div>
    </div> -->
    <div class="-mx-[4vw]">
      <div class="w-full overflow-y-scroll no-scrollbar px-[4vw]">
        <div class="flex items-stretch gap-6 sm:gap-x-8">
          <div class="max-md:min-w-[14rem] w-full" :class="{ 'md:w-full': meals.length === 1, 'md:w-1/2': meals.length === 2, 'md:w-1/3': meals.length === 3, 'md:w-1/4': meals.length >= 4 }" v-for="meal, key in meals?.slice(0, 4)" :key="meal.id">
            <OffersListCard 
              :horizontal="key > 11"
              :position="key+1"
              :meal="meal" 
              :restaurant="meal?.restaurant" />
          </div>
          <div class="w-0 !opacity-0 md:hidden">&nbsp;</div>
        </div>
      </div>
    </div>
    <NuxtLink class="flex items-center gap-2" :to="`/${$t('routes.offers')}/${fat.city?.slug}`">
      <div class="w-5 h-5 flex items-center justify-center rounded-full bg-sky text-ocean">
        <AtomIcon name="chevron-right" class="text-sm" />
      </div>
      <div class="text-sm">{{ $t('shared.allOffers', { city: fat.city?.name }) }}</div>
    </NuxtLink>
  </div>
</template>

<script setup>
const { t } = useI18n()
const route = useRoute()
const fat = useFatStore()

const date = computed(() => {
  const now = toDayjs()
  const cutoffHour = 21

  return now.hour() < cutoffHour
    ? now.format('YYYY-MM-DD')
    : now.add(1, 'day').format('YYYY-MM-DD')
})

const dayLabel = computed(() => toDayjs(date.value).isToday() ? t('shared.tonight') : t('shared.tomorrow'))

// Fetch FAT result for Offers
const { data } = await useFetch('/search/fat', {
  key: `offers-start-${fat.city?.id}`,
  baseURL: useEnv('apiBase'),
  query: {
    scope: 'bokabord.se',
    bookable: true,
    date: computed(() => date.value),
    cityIds: computed(() => fat.cityIds?.join(',')),
    amount: computed(() => fat.amount || 2),
    mealTypes: 11,
    altType: computed(() => route.query?.altType
      ? route.query?.altType
      : toDayjs(date.value).isToday() ? '1,2,3' : '1,2'),
    waitlist: false,
    // includeEmptyTimeslots: false,
    includeRestaurantData: true,
    promotionTypes: 'offers',
  }
})

// Get offer meals from FAT response
const meals = computed(() => useOffersFromFat(data.value?.data?.restaurants))
</script>